import { useState } from 'react';

export const useModal = (initialState = false) => {
  const [visible, setVisible] = useState(initialState);

  const showModal = () => setVisible(true);
  const hideModal = () => setVisible(false);

  return [visible, showModal, hideModal] as const;
};
